/*门诊诊疗打印模板2*/
export const outpatientsDiagnosis2 = {
    panels: [
        {
            index: 0,
            paperType: "A4",
            height: 297,
            width: 210,
            paperHeader: -1.5,
            paperFooter: 841.8897637795277,
            printElements: [
                {
                    options: {
                        left: 10.5,
                        top: 22.5,
                        height: 801,
                        width: 573
                    },
                    printElementType: {
                        type: "rect"
                    }
                },
                {
                    options: {
                        left: 13.5,
                        top: 25.5,
                        height: 105,
                        width: 567,
                        tableHeaderCellBorder: "border",
                        tableHeaderRowHeight: 30.75,
                        tableHeaderBackground: "#ffffff",
                        tableBodyRowHeight: 30.75,
                        columns: [
                            [
                                {
                                    title: "患者主诉:",
                                    field: "",
                                    width: 90.77274154029743,
                                    align: "center",
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 476.22725845970257,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ]
                        ]
                    },
                    printElementType: {
                        title: "表格",
                        type: "tableCustom"
                    }
                },
                {
                    options: {
                        left: 106.5,
                        top: 28.5,
                        height: 25.5,
                        width: 471,
                        field: "patientTell"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 13.5,
                        top: 55.5,
                        height: 48,
                        width: 567,
                        tableHeaderRowHeight: 30.75,
                        tableHeaderBackground: "#ffffff",
                        columns: [
                            [
                                {
                                    title: "门（急）诊诊断",
                                    field: "",
                                    width: 326.1444441624367,
                                    align: "center",
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true,
                                    columnId: ""
                                },
                                {
                                    title: "疾病编码",
                                    field: "",
                                    width: 240.8555558375633,
                                    align: "center",
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true,
                                    columnId: ""
                                }
                            ]
                        ]
                    },
                    printElementType: {
                        title: "表格",
                        type: "tableCustom"
                    }
                },
                {
                    options: {
                        left: 13.5,
                        top: 79.5,
                        height: 234,
                        width: 567,
                        tableHeaderRowHeight: 30.75,
                        tableHeaderBackground: "#ffffff",
                        tableBodyRowHeight: 30.75,
                        field: "diagnosticName",
                        columns: [
                            [
                                {
                                    title: "西医诊断:",
                                    width: 115.15298520260511,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 224.64744497105642,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 251.19956982633852,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ],
                            [
                                {
                                    title: "",
                                    field: "",
                                    width: 115.15298520260511,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 224.64744497105642,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 251.19956982633852,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ],
                            [
                                {
                                    title: " ",
                                    field: "",
                                    width: 115.15298520260511,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true,
                                    columnId: ""
                                },
                                {
                                    title: " ",
                                    field: "",
                                    width: 224.64744497105642,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: " ",
                                    field: "",
                                    width: 251.19956982633852,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ],
                            [
                                {
                                    title: " 中医诊断",
                                    width: 115.15298520260511,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: " ",
                                    field: "",
                                    width: 224.64744497105642,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: " ",
                                    width: 251.19956982633852,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ],
                            [
                                {
                                    title: " ",
                                    field: "",
                                    width: 110.47672184412367,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true,
                                    columnId: ""
                                },
                                {
                                    title: " ",
                                    field: "",
                                    width: 215.52470608898304,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true,
                                    columnId: ""
                                },
                                {
                                    title: " ",
                                    field: " ",
                                    width: 240.99857206689327,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true,
                                    columnId: " "
                                }
                            ],
                            [
                                {
                                    width: 110.47672184412367,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 215.52470608898304,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 240.99857206689327,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ]
                        ]
                    },
                    printElementType: {
                        title: "表格",
                        type: "tableCustom"
                    }
                },
                {
                    options: {
                        left: 127.5,
                        top: 82.5,
                        height: 24,
                        width: 205.5,
                        field: "diagnosticName1"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 345,
                        top: 82.5,
                        height: 24,
                        width: 231,
                        field: "icdCode1"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 345,
                        top: 112.5,
                        height: 25.5,
                        width: 231,
                        field: "icdCode2"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 127.5,
                        top: 112.5,
                        height: 24,
                        width: 205.5,
                        field: "diagnosticName2"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 127.5,
                        top: 144,
                        height: 24,
                        width: 205.5,
                        field: "diagnosticName3"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 345,
                        top: 144,
                        height: 24,
                        width: 231,
                        field: "icdCode3"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 345,
                        top: 175.5,
                        height: 24,
                        width: 231,
                        field: "icdCode4"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 127.5,
                        top: 175.5,
                        height: 24,
                        width: 205.5,
                        field: "diagnosticName4"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 127.5,
                        top: 205.5,
                        height: 24,
                        width: 205.5,
                        field: "diagnosticName5"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 345,
                        top: 207,
                        height: 22.5,
                        width: 231,
                        field: "icdCode5"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 127.5,
                        top: 237,
                        height: 22.5,
                        width: 205.5,
                        field: "diagnosticName6"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 345,
                        top: 237,
                        height: 21,
                        width: 231,
                        field: "icdCode6"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 13.5,
                        top: 264,
                        height: 123,
                        width: 567,
                        textAlign: "center",
                        tableHeaderRowHeight: 30.75,
                        tableHeaderBackground: "#ffffff",
                        tableBodyRowHeight: 30.75,
                        columns: [
                            [
                                {
                                    title: "手术及操作日期",
                                    width: 295.5,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "手术及操作名称",
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "手术及操作编码",
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "手术及操作者",
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "麻醉方式",
                                    field: "",
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "麻醉医师",
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "手术分级管理级别",
                                    width: 295.5,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ],
                            [
                                {
                                    title: "",
                                    field: "",
                                    width: 295.5,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true,
                                    columnId: ""
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 295.5,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ],
                            [
                                {
                                    width: 295.5,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    title: "",
                                    field: "",
                                    width: 295.5,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true,
                                    columnId: ""
                                }
                            ],
                            [
                                {
                                    width: 295.5,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 100,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 295.5,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ],
                            [
                                {
                                    width: 71.03752081327838,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 125.70542211719228,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 87.0635973689212,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 103.17934047984603,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 57.2739326017897,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 61.74165265620863,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                },
                                {
                                    width: 60.998533962763815,
                                    colspan: 1,
                                    rowspan: 1,
                                    checked: true
                                }
                            ]
                        ]
                    },
                    printElementType: {
                        title: "表格",
                        type: "tableCustom"
                    }
                },
                {
                    options: {
                        left: 357,
                        top: 393,
                        height: 24,
                        width: 190.5,
                        title: "(自付金额",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 231,
                        top: 393,
                        height: 24,
                        width: 123,
                        title: "总费用",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "totalCost"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 393,
                        height: 24,
                        width: 219,
                        title: "门（急）诊费用（元）",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "totalCost"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 540,
                        top: 394.5,
                        height: 22.5,
                        width: 48,
                        title: ")",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 427.5,
                        top: 408,
                        height: 9,
                        width: 111
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 133.5,
                        top: 417,
                        height: 21,
                        width: 219,
                        title: "（1）一般医疗服务费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 348,
                        top: 417,
                        height: 21,
                        width: 238.5,
                        title: "（2）一般治疗操作费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 417,
                        height: 21,
                        width: 142.5,
                        title: "1.综合医疗服务类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 276,
                        top: 432,
                        height: 9,
                        width: 72
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 493.5,
                        top: 432,
                        height: 9,
                        width: 90
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 307.5,
                        top: 441,
                        height: 22.5,
                        width: 261,
                        title: "（4）其他费用 ",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 121.5,
                        top: 441,
                        height: 22.5,
                        width: 186,
                        title: "（3）护理费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 202.5,
                        top: 456,
                        height: 9,
                        width: 100.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 402,
                        top: 456,
                        height: 9,
                        width: 163.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 240,
                        top: 469.5,
                        height: 21,
                        width: 187.5,
                        title: "（6）实验室诊断费 ",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 72,
                        top: 469.5,
                        height: 21,
                        width: 171,
                        title: "（5）病理诊断费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 415.5,
                        top: 469.5,
                        height: 21,
                        width: 175.5,
                        title: "（7）影像学诊断费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 469.5,
                        height: 21,
                        width: 81,
                        title: "2.诊断类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 367.5,
                        top: 483,
                        height: 9,
                        width: 55.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 546,
                        top: 483,
                        height: 9,
                        width: 31.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 183,
                        top: 484.5,
                        height: 9,
                        width: 55.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 72,
                        top: 490.5,
                        height: 19.5,
                        width: 382.5,
                        title: "（8）临床诊断项目费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 202.5,
                        top: 505.5,
                        height: 9,
                        width: 120
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 552,
                        top: 508.5,
                        height: 15,
                        width: 25.5,
                        title: ")",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 72,
                        top: 508.5,
                        height: 18,
                        width: 271.5,
                        title: "（9）非手术治疗项目费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 336,
                        top: 510,
                        height: 19.5,
                        width: 235.5,
                        title: "（临床物理治疗费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 510,
                        height: 18,
                        width: 79.5,
                        title: "3.治疗类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 228,
                        top: 523.5,
                        height: 9,
                        width: 112.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 454.5,
                        top: 523.5,
                        height: 9,
                        width: 96
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 399,
                        top: 529.5,
                        height: 18,
                        width: 142.5,
                        title: "手术费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 265.5,
                        top: 529.5,
                        height: 18,
                        width: 130.5,
                        title: "（麻醉费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 70.5,
                        top: 529.5,
                        height: 18,
                        width: 211.5,
                        title: "（10）手术治疗费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 532.5,
                        top: 531,
                        height: 18,
                        width: 34.5,
                        title: "）",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "longText"
                    }
                },
                {
                    options: {
                        left: 189,
                        top: 544.5,
                        height: 9,
                        width: 79.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 327,
                        top: 544.5,
                        height: 9,
                        width: 69
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 444,
                        top: 544.5,
                        height: 9,
                        width: 90
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 70.5,
                        top: 549,
                        height: 21,
                        width: 235.5,
                        title: "（11）康复费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 549,
                        height: 21,
                        width: 78,
                        title: "4.康复类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 160.5,
                        top: 562.5,
                        height: 9,
                        width: 142.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 573,
                        height: 22.5,
                        width: 76.5,
                        title: "5.中医类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 70.5,
                        top: 574.5,
                        height: 22.5,
                        width: 244.5,
                        title: "（12）中医治疗费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 189,
                        top: 589.5,
                        height: 9,
                        width: 124.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 270,
                        top: 598.5,
                        height: 22.5,
                        width: 210,
                        title: "（抗菌药物费用",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 70.5,
                        top: 598.5,
                        height: 22.5,
                        width: 204,
                        title: "（13）西药费",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "drxCost"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 475.5,
                        top: 598.5,
                        height: 22.5,
                        width: 31.5,
                        title: "）",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 598.5,
                        height: 22.5,
                        width: 76.5,
                        title: "6.西药类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 375,
                        top: 612,
                        height: 9,
                        width: 103.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 166.5,
                        top: 613.5,
                        height: 9,
                        width: 97.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 70.5,
                        top: 624,
                        height: 18,
                        width: 204,
                        title: "（14）中成药费",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "drxTcmCost"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 271.5,
                        top: 624,
                        height: 18,
                        width: 217.5,
                        title: "（15）中草药费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 624,
                        height: 18,
                        width: 76.5,
                        title: "7.中药类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 183,
                        top: 639,
                        height: 9,
                        width: 79.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 375,
                        top: 639,
                        height: 9,
                        width: 103.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 295.5,
                        top: 646.5,
                        height: 21,
                        width: 292.5,
                        title: "（17）白蛋白类制品费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 148.5,
                        top: 646.5,
                        height: 21,
                        width: 153,
                        title: "（16）血费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 646.5,
                        height: 22.5,
                        width: 151.5,
                        title: "8.血液和血液制品类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 223.5,
                        top: 661.5,
                        height: 9,
                        width: 76.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 445.5,
                        top: 661.5,
                        height: 9,
                        width: 123
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 306,
                        top: 675,
                        height: 24,
                        width: 292.5,
                        title: "（19）凝血因子类制品费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 675,
                        height: 24,
                        width: 280.5,
                        title: "（18）球蛋白类制品费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 160.5,
                        top: 690,
                        height: 9,
                        width: 115.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 460.5,
                        top: 690,
                        height: 9,
                        width: 109.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 699,
                        height: 22.5,
                        width: 280.5,
                        title: "（20）细胞因子类制品费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 174,
                        top: 712.5,
                        height: 9,
                        width: 114
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 72,
                        top: 727.5,
                        height: 19.5,
                        width: 273,
                        title: "（21）检查用一次性医用材料费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 321,
                        top: 727.5,
                        height: 19.5,
                        width: 265.5,
                        title: "（22）治疗用一次性医用材料费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 729,
                        height: 19.5,
                        width: 78,
                        title: "9.耗材类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 282,
                        top: 741,
                        height: 9,
                        width: 45
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 532.5,
                        top: 741,
                        height: 9,
                        width: 45
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 72,
                        top: 747,
                        height: 24,
                        width: 427.5,
                        title: "（23）手术用一次性医用材料费",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 282,
                        top: 760.5,
                        height: 9,
                        width: 175.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 84,
                        top: 777,
                        height: 21,
                        width: 225,
                        title: "（24）其他费用",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 777,
                        height: 21,
                        width: 88.5,
                        title: "10.其他类：",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 189,
                        top: 790.5,
                        height: 9,
                        width: 115.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                }
            ],
            paperNumberLeft: 565.5,
            paperNumberTop: 820.5,
            paperNumberDisabled: true
        }
    ]
}